import React, { useEffect } from 'react'
import RadioButtons from '../../../../components/common/inputs/RadioButtons'
import { requiredAndNumberRules, requiredRule } from '../helpers/ValidationRules'
import { StepProps } from '../types/RoiCalculatorTypes'
import PriceField from './PriceField'
import NumberField from './NumberField'
import I18n from '../../../../helpers/I18n'

const EquipmentAutomationFields: React.FC<StepProps> = ({
  formControl,
  exchangeRate,
  design,
  watchedFields,
}) => {
  useEffect(() => {
    if (design) {
      formControl.setValue('equipmentHardwareCost', design?.total_price)
    } else {
      formControl.setValue('equipmentHardwareCost', undefined)
    }
  }, [design])

  const validateAutomatedProcess = {
    required: value =>
      parseInt(value) >= 0 || (value === '' && !watchedFields?.manualProcess)
        ? true
        : I18n.t('views.roi_calculator.form.errors.automated_process'),
    positive: value =>
      parseInt(value) >= 0 || value === ''
        ? true
        : I18n.t('views.roi_calculator.form.errors.positive'),
  }

  return (
    <>
      <div className='roi-calculator-step-inner'>
        <PriceField
          name='equipmentHardwareCost'
          formControl={formControl}
          rules={requiredAndNumberRules}
          label={I18n.t('views.roi_calculator.form.labels.hardware_cost')}
          infoTip={I18n.t('views.roi_calculator.form.tooltips.hardware_cost')}
          currencyUnit={design?.currency_code || exchangeRate.currency_code}
          currencySymbol={design?.currency_symbol || exchangeRate.currency_symbol}
          disabled={!!design}
        />
        <RadioButtons
          label={I18n.t('views.roi_calculator.form.labels.equipment_efficiency')}
          {...formControl.register('estimatedEquipmentEfficiency', requiredRule)}
          errorMessage={formControl.formState.errors.estimatedEquipmentEfficiency?.message?.toString()}
          options={[
            { value: 0.8, label: '80%' },
            { value: 0.85, label: '85%' },
            { value: 0.9, label: '90%' },
            { value: 0.95, label: '95%' },
            { value: 1, label: '100%' },
          ]}
          infoTip={I18n.t('views.roi_calculator.form.tooltips.equipment_efficiency')}
        />
        <NumberField
          name='automatedProcess'
          formControl={formControl}
          label={[
            I18n.t('views.roi_calculator.form.labels.automated_process'),
            <em className='roi-calculator-optional' key='automated-process'>
              ({I18n.t('views.roi_calculator.form.labels.optional')})
            </em>,
          ]}
          infoTip={I18n.t('views.roi_calculator.form.tooltips.automated_process')}
          endAdornment={I18n.t('datetime.units.seconds')}
          decimalScale={2}
          rules={{ validate: validateAutomatedProcess }}
        />
      </div>
    </>
  )
}

export default EquipmentAutomationFields
